import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=06971196&scoped=true&"
import script from "./ProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=06971196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06971196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06971196')) {
      api.createRecord('06971196', component.options)
    } else {
      api.reload('06971196', component.options)
    }
    module.hot.accept("./ProfileSettings.vue?vue&type=template&id=06971196&scoped=true&", function () {
      api.rerender('06971196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/ProfileSettings.vue"
export default component.exports